// const PHONE_NUMBER_FORMAT = /^[0]?[123456789]\d{9}$/; /** When we need Starting Number restriction, remoive the numbers which are not required */
export const supportModalHeading1 = "Thank you for submitting the form! Your request has been received."
export const supportModalHeading2 = "We appreciate your interest in Osan Grows. Our team will review your submission promptly."
export const EmailModalHeading = "Email Verification"
export const ShareManagementHeading = "Share Management"
export const ShareReportHeading="Reports"
export const ToolTipText2027_2028= "Please note to make a change for the year 2027, 2028 and 2029, changes has to be done in the year 2029 as the data is shown in one single box on the website for all these years."
export const ToolTipText2031_2032= "Please note to make a change for the year 2027, 2028 and 2029, changes has to be done in the year 2029 as the data is shown in one single box on the website for all these years."
export const ErrorMessageShareMangement = "Please enter Share Name and Share Value fields"
export const DisableModalContentText = "Are you sure want to disable the shares?"
export const EnableModalContentText = "Are you sure want to enable the shares?"
export const DisableUserModalText = "stocks in their account.Still, do you want to proceed for disable this customer?"
export const EnableUserModalText = "Are you sure want to enable this user?"
export const EmailOrLoginText = "Please enter mobile number or email ID"
export const ValidMobileNumberText = "Please enter a valid mobile number"
export const ValidEmailIdText = "Please enter a valid email ID"
export const homeAdditionalServiceText = "Additional Services"
export const TextHeaderFirstName = 'First Name *'
export const TextHeaderLastName='Last Name *'
export const TextHeaderUserType='User Type *'
export const TextHeaderPhoneNumber='Phone number *'
export const TextHeaderEmail='Email *'
export const TextHeaderState='State *'
export const TextHeaderCity=' City *'
export const TextHeaderPincode ='Pincode *'
export const TextHeaderAddress ='Address *'
export const TextHeaderDematAccount = 'Demat Account'
export const TextHeaderSelectBank ='Select Bank *'
export const TextHeaderNameOnBank ='Name as per the bank records *'
export const TextHeaderAccountNumber='Account Number *'
export const TextHeaderConfirmAccountNumber ='Confirm Account Number *'
export const TextHeaderIfscCode='IFSC Code'
export const MobileOtpText= 'Enter the verification code we just sent to your mobile number +91'
export const EmailOtpText ='Enter the verification code we just sent to your email'
export const TextLoginEmailOtp = 'Enter your mobile number or email-Id to receive an OTP'
export const OtpSentTextMessageEmail = 'Please enter the otp sent to the email id'
export const OtpSentTextMobileNumber = 'Please enter the otp sent to your mobile number +91'
export const ErrorMessageShareQunatiy = 'Please enter the share quantity to update'
export const ErrorMessageshareAmount = 'Please enter the amount to update'
export const ErrorTextMessage = 'Please enter the Message fields'
export const ErrorTextDateMessage = 'End date can not be previous date than the start date'
export const EndDateValidationMessage = 'Please enter the end date'
export const StartDateValidationMessage ='Please enter the start date'
export const NoDataToExportMessage = 'Found no data to export'
export const EmailVerificationPendingMessage= 'Your Email ID is not verified. Please click on the button below to verify your email ID'
export const NumberVerificationPendingMessage = 'Your mobile number is not verified. Please click on the button below to verify your mobile number'
export const UserDepetailsPath = '/admin/userManagement/userDetailedView'
export const rowPerPageDataArray = [10, 25,50,100]
export const rowPerPageDataHome =[11,25,50,100]
export const holidaysData = [
  {
      id: 1,
      day: "Sunday"
  },
  {
      id: 2,
      day: "Monday"
  },
  {
      id: 3,
      day: "Tuesday"
  },
  {
      id: 4,
      day: "Wednesday"
  },
  {
      id: 5,
      day: "Thusday"
  },
  {
      id: 6,
      day: "Friday"
  },
  {
      id: 7,
      day: "Saturday"
  },

]

export const EmailModalDescription = "An OTP has been sent to your registered email for verification. Please enter the OTP"
const PHONE_NUMBER_FORMAT = /^[1-9][0-9]*$/;
const ALPHANUMERIC = /^[a-zA-Z0-9]*$/;
const EMAIL =
  /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
export const validEmail = /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i

/** check if a valid phone number */
const isValidPhoneNumber = (phoneNumber) => {
  return (
    PHONE_NUMBER_FORMAT.test(phoneNumber) &&
    phoneNumber.length <= 10 &&
    phoneNumber.length >= 7
  );
};

/** check if it is the valid email or not */
const isValidEmail = (email) => {
  return EMAIL.test(email);
};

const isAlphaNumeric = (text) => {
  return ALPHANUMERIC.test(text);
};

const getRandomInt = (max) => {
  return Math.floor(Math.random() * Math.floor(max));
};

const fullNumbers = (text) => text.replace(/[^0-9]/g, "");
const getMaskedDigit = (value) => (value ? "*" : "");
/** handles keyboard backspace event */
const onKeyPressEvent = (nativeEvent, value, nextFocus) =>
  nativeEvent.key === "Backspace"
    ? value === ""
      ? nextFocus.focus()
      : {}
    : {};

const showLoadingIndicator = () => {
  const loaderEl = document.getElementById("loader");
  if (loaderEl) loaderEl.style.display = "flex";
};

const hideLoadingIndicator = () => {
  const loaderEl = document.getElementById("loader");
  if (loaderEl) loaderEl.style.display = "none";
};

export const TextInputUtils = {
  fullNumbers,
  getMaskedDigit,
  onKeyPressEvent,
  isValidPhoneNumber,
  isValidEmail,
  isAlphaNumeric,
  getRandomInt,
  showLoadingIndicator,
  hideLoadingIndicator,
};


